import { render, staticRenderFns } from "./queryDrawBillHis.vue?vue&type=template&id=72ea23d4&scoped=true"
import script from "./queryDrawBillHis.vue?vue&type=script&lang=js"
export * from "./queryDrawBillHis.vue?vue&type=script&lang=js"
import style0 from "./queryDrawBillHis.vue?vue&type=style&index=0&id=72ea23d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ea23d4",
  null
  
)

export default component.exports